module.exports = __webpack_public_path__ + "img/pie_leave.f167ec03.png";